import * as types from "./types";

export const touch = {
  namespaced: true,

  state: {
    stagePos: {
      x: 0,
      y: 0
    },
    mousePos: {
      x: 0,
      y: 0
    }
  },
  getters: {
  },
  mutations: {
    setStagePos(state, pos) {
      state.stagePos.x = pos.x;
      state.stagePos.y = pos.y;
    },
    setMousePos(state, pos) {
      state.mousePos.x = pos.x;
      state.mousePos.y = pos.y;
    }
  },
  actions: {
    [types.SET_STAGE_POS]({ commit }, pos) {
      commit("setStagePos", pos);
    },
    [types.SET_MOUSE_POS]({ commit }, pos) {
      commit("setMousePos", pos);
    }
  }
};
